export enum HHDSCheckboxGroupState {
  Default = "default",
  Error = "error",
}
